import React from "react";
import { RiHome2Fill } from "react-icons/ri";
import { IoCart } from "react-icons/io5";
import { IoBag } from "react-icons/io5";
import { FaCubes } from "react-icons/fa";
import { BsWalletFill } from "react-icons/bs";
import { FaFileAlt } from "react-icons/fa";
import { FaCheckCircle } from "react-icons/fa";
import { IoMdSettings } from "react-icons/io";
import {
  FaTachometerAlt,
  FaUsers,
  FaUserFriends,
  FaExchangeAlt,
  FaChartBar,
  FaListAlt,
  FaTag,
  FaShoppingCart,
  FaTicketAlt,
  FaBan,
  FaLayerGroup,
  FaBox,
  FaIdBadge,
  FaUpload,
  FaDollarSign,
  FaTruck,
  FaUserCog,
  FaEnvelopeOpenText,
  FaStar,
  FaSearch,
  FaStore,
  FaClock,
  FaUserShield,
  FaGlobe,
  FaWarehouse,
} from "react-icons/fa";
export default function IconWrapper({ name, className }) {
  const iconComponents = {
    RiHome2Fill: RiHome2Fill,
    IoCart: IoCart,
    IoBag: IoBag,
    FaCubes: FaCubes,
    BsWalletFill: BsWalletFill,
    FaFileAlt: FaFileAlt,
    IoMdSettings: IoMdSettings,
    FaTachometerAlt: FaTachometerAlt,
    FaUsers: FaUsers,
    FaUserFriends: FaUserFriends,
    FaExchangeAlt: FaExchangeAlt,
    FaChartBar: FaChartBar,
    FaListAlt: FaListAlt,
    FaTag: FaTag,
    FaShoppingCart: FaShoppingCart,
    FaTicketAlt: FaTicketAlt,
    FaBan: FaBan,
    FaLayerGroup: FaLayerGroup,
    FaBox: FaBox,
    FaIdBadge: FaIdBadge,
    FaUpload: FaUpload,
    FaDollarSign: FaDollarSign,
    FaTruck: FaTruck,
    FaCheckCircle: FaCheckCircle,
    FaUserCog: FaUserCog,
    FaEnvelopeOpenText: FaEnvelopeOpenText,
    FaStar: FaStar,
    FaSearch: FaSearch,
    FaStore: FaStore,
    FaClock: FaClock,
    FaUserShield: FaUserShield,
    FaGlobe: FaGlobe,
    FaWarehouse: FaWarehouse,
  };

  // Retrieve the corresponding icon component based on the provided name
  const IconComponent = iconComponents[name];

  // Return null if icon not found
  if (!IconComponent) return null;

  // Render the retrieved icon component
  return <IconComponent className={className} />;
}
